import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

const fallbackServices = [
    {
        count: 1,
        title: 'Architecture Design',
        icon: require('./../../images/icon/compass.png'),
        image: require('./../../images/services/1.jpg'),
        description: 'Comprehensive architectural concepts designed to inspire and withstand the test of time.',
    },
    {
        count: 2,
        title: 'Building Construction',
        icon: require('./../../images/icon/crane-1.png'),
        image: require('./../../images/services/3.jpg'),
        description: 'Quality structural engineering and commercial builds engineered to safety and excellence.',
    },
    {
        count: 3,
        title: 'Building Renovation',
        icon: require('./../../images/icon/renovation.png'),
        image: require('./../../images/services/2.jpg'),
        description: 'Modernizing spaces, increasing functionality, and restoring structural beauty.',
    }   
];

class Services extends React.Component {
    state = {
        services: fallbackServices,
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.SERVICES.GET_ALL)
            .then(res => {
                const apiServices = res.data.data || [];
                if (apiServices.length > 0) {
                    const mapped = apiServices.slice(0, 3).map((s, idx) => ({
                        count: idx + 1,
                        title: s.name,
                        icon: fallbackServices[idx % fallbackServices.length].icon,
                        image: s.image_url || fallbackServices[idx % fallbackServices.length].image,
                        description: s.description || fallbackServices[idx % fallbackServices.length].description
                    }));
                    this.setState({ services: mapped, loading: false });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                console.error("Error fetching services", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { services } = this.state;
        return (
            <>
                <div className="section-full bg-white slider-half-part">
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                                {services.map((item, index) => (
                                    <div className="col-md-4 col-sm-4 m-b30" key={index}>
                                        <div className="half-blocks">
                                            <div className="mt-icon-box-wraper center m-b30">
                                                <div className="half-block-content icon-count-2 p-a30 p-tb50">
                                                    <span className="icon-count-number">{item.count}</span>
                                                    <div className="mt-icon-box-lg radius bg-gray m-b20 scale-in-center">
                                                        <span className="icon-cell"><img src={item.icon} alt=""/></span>
                                                    </div>
                                                    <div className="icon-content">
                                                        <h4 className="mt-tilte m-b25">{item.title}</h4>
                                                        <p>{item.description}</p>
                                                        <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                                    </div>
                                                </div>
                                                <div className="bg-cover  half-blocks-bg" style={{ backgroundImage: 'url(' + item.image + ')' }} />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Services;
